import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { delay, tap } from 'rxjs/operators';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Lesson } from './lesson.model';
import { LessonPopupService } from './lesson-popup.service';
import { LessonService } from './lesson.service';
import { CRUD_ACTIONS } from '../../shared';
import { LESSONS_BULK_SAVE_WAIT_TIME_MILLIS } from '../../shared/constants/lesson.constants';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-lesson-delete-dialog',
    templateUrl: './lesson-delete-dialog.component.html'
})
export class LessonDeleteDialogComponent {

    lesson: Lesson;
    readonly SINGLE_DELETE_ACTION = 'SINGLE_DELETE';
    readonly BULK_DELETE_ACTION = 'BULK_DELETE';
    deleteAction: string = this.SINGLE_DELETE_ACTION;
    isDeletingBulk: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private lessonService: LessonService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager,
        private router: Router
    ) {
        this.isDeletingBulk = false;
    }

    clear() {
        this.isDeletingBulk = false;
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        if (this.deleteAction === this.SINGLE_DELETE_ACTION) {
            this.lessonService.delete(id).subscribe(response => {
                this.eventManager.broadcast({
                    name: 'lessonListModification',
                    content: {
                        action: CRUD_ACTIONS.DELETE,
                        content: {id: id}
                    }
                });
                this.activeModal.dismiss(true);
            },
                (error: HttpErrorResponse) => {
                    this.isDeletingBulk = false;
            });

        } else {
            this.isDeletingBulk = true;

            this.lessonService.bulkDelete(id).pipe(
                                delay(LESSONS_BULK_SAVE_WAIT_TIME_MILLIS), // Introduces a delay before processing the result
                                tap(() => {
                                    this.eventManager.broadcast({
                                        name: 'lessonBulkDeletion',
                                        content: {
                                            action: CRUD_ACTIONS.DELETE,
                                            content: {id: id}
                                        }
                                    });
                                    this.isDeletingBulk = false;
                                    this.activeModal.dismiss(true);
                                })
                            ).subscribe(
                                (res) => {
                                    // Handle success if needed (already in tap)
                                },
                                (error: HttpErrorResponse) => {
                                    this.isDeletingBulk = false;
                                }
                            );

        }

    }
}

@Component({
    selector: 'jhi-lesson-delete-popup',
    template: ''
})
export class LessonDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private lessonPopupService: LessonPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.lessonPopupService
                .open(LessonDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson-delete-dialog.component.ts